@if (data().length <= 1) {
    <ng-container *ngTemplateOutlet="codePreviewer; context: { $implicit: data()[0] }" />
} @else {
    <p-tabs [value]="data()[0].language">
        <p-tablist>
            @for (snippet of data(); track snippet) {
                <p-tab [value]="snippet.language">{{ snippet.languageDisplayName ?? snippet.language }}</p-tab>
            }
        </p-tablist>

        <p-tabpanels>
            @for (snippet of data(); track snippet) {
                <p-tabpanel [value]="snippet.language">
                    <ng-container *ngTemplateOutlet="codePreviewer; context: { $implicit: snippet }" />
                </p-tabpanel>
            }
        </p-tabpanels>
    </p-tabs>
}

<ng-template
    #codePreviewer
    let-snippet>
    <pre><code [highlight]="snippet.code" [language]="snippet.language" lineNumbers></code></pre>
</ng-template>
